import { Button, Form, Input, Modal, Typography } from 'antd'
import { useAuthStore } from '@/store'
import { createLocators } from '@/shared'

type FieldType = {
  email?: string
  password?: string
}

const { locators: locator } = createLocators({
  name: 'LoginPage',
  componentLocators: ['root', 'emailInput', 'passwordInput', 'loginButton'],
})()

export const Login = () => {
  const { login, state, isLoading } = useAuthStore((state) => state)

  const onSubmit = (data: { email: string; password: string }) => {
    login(data)
  }

  return (
    <>
      <Modal open={state === 'login'} closable={false} footer={null}>
        <Form
          {...locator.root()}
          name='basic'
          layout='vertical'
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          onFinish={onSubmit}
          autoComplete='off'>
          <Typography.Title level={5} style={{ margin: '20px 0' }}>
            Login
          </Typography.Title>
          <Form.Item<FieldType>
            label='Username'
            name='email'
            rules={[{ required: true, message: 'Please input your username!' }]}>
            <Input autoComplete='email' {...locator.emailInput()} />
          </Form.Item>

          <Form.Item<FieldType>
            label='Password'
            name='password'
            rules={[{ required: true, message: 'Please input your password!' }]}>
            <Input.Password autoComplete='password' {...locator.passwordInput()} />
          </Form.Item>

          <Button
            type='primary'
            htmlType='submit'
            style={{ width: '100%' }}
            loading={isLoading}
            {...locator.loginButton()}>
            Login
          </Button>
        </Form>
      </Modal>
    </>
  )
}
